var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Alert',{attrs:{"type":"warning","show-icon":"","closable":""}},[_vm._v("\n  表格样式注意事项：\n  "),_c('template',{slot:"desc"},[_c('p',[_vm._v("当使用斑马纹时，为突出表头，将其高亮显示")]),_c('p',[_vm._v("注：当前示例仅为样式示例")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }